import { audioTest } from './audioFingerprint.ts';
import { batteryTest } from './battery.ts';
import { browserIdentityTest } from './browserIdentity.ts';
import { canvasRenderingTest } from './canvasRendering.ts';
import { chromeCapabilitiesTest } from './chromeCapabilities.ts';
import { cpuCountTest } from './cpuCount.ts';
import { crossRealmTest } from './crossRealmConsistency.ts';
import { cssSystemTest } from './windowsCssAppearance.ts';
import { deviceMemoryTest } from './deviceMemory.ts';
import { domSvgGeometryTest } from './domSvgGeometry.ts';
import { eventTrustOverrideTest } from './eventTrustOverride.ts';
import { eventSurfaceTest } from './eventSurface.ts';
import { extensionsTest } from './extensions.ts';
import { featureInventoryTest } from './browserFeatures.ts';
import { fontsTest } from './fonts.ts';
import { http3SupportTest } from './http3Support.ts';
import { javascriptRuntimeTest } from './javascriptRuntime.ts';
import { keyboardLayoutMapTest } from './keyboardLayoutMap.ts';
import { localeIntlTest } from './locale.ts';
import { localVoicesTest } from './localVoices.ts';
import { mediaCodecsDrmTest } from './mediaCodecsDrm.ts';
import { mediaDevicesTest } from './mediaDevices.ts';
import { networkInformationTest } from './networkInformation.ts';
import { ja4FingerprintTest } from './ja4Fingerprint.ts';
import { permissionPolicyTest } from './permissionPolicy.ts';
import { publicIpTest } from './publicIp.ts';
import { proxyFunctionalityTest } from './proxyFunctionality.ts';
import { quicConnectionTest } from './quicConnection.ts';
import { rawCdpVisibilityTest } from './rawCdpVisibility.ts';
import { remoteVoicesTest } from './remoteVoices.ts';
import { screenDprTest } from './screenDpr.ts';
import { stabilityTest } from './fingerprintStability.ts';
import { storageCapabilitiesTest } from './storageCapabilities.ts';
import { storageEstimateTest } from './storageEstimate.ts';
import { timezoneTest } from './timezone.ts';
import { viewportTest } from './controlledViewport.ts';
import { webGlRendererTest } from './webglRenderer.ts';
import { webGlRenderingTest } from './webglRendering.ts';
import { webGlVendorTest } from './webglVendor.ts';
import { webGpuAdapterTest } from './webgpuAdapter.ts';
import { webGpuRenderingTest } from './webgpuRendering.ts';
import { webGpuVendorTest } from './webgpuVendor.ts';
import { webIdlSurfaceTest } from './webApiSurface.ts';
import { webRtcTest } from './webrtc.ts';
import { webRtcLocalFunctionalityTest } from './webrtcLocalFunctionality.ts';
import { webRtcRemoteFunctionalityTest } from './webrtcRemoteFunctionality.ts';
import { workerFunctionalityTest } from './workerFunctionality.ts';
import type { TestDefinition } from '../types.ts';

export const tests: readonly TestDefinition[] = [
  cpuCountTest,
  deviceMemoryTest,
  publicIpTest,
  webRtcTest,
  webRtcLocalFunctionalityTest,
  webRtcRemoteFunctionalityTest,
  timezoneTest,
  webGlRendererTest,
  webGpuAdapterTest,
  fontsTest,
  localVoicesTest,
  networkInformationTest,
  batteryTest,
  workerFunctionalityTest,
  storageEstimateTest,
  extensionsTest,
  permissionPolicyTest,
  browserIdentityTest,
  remoteVoicesTest,
  localeIntlTest,
  keyboardLayoutMapTest,
  webGlVendorTest,
  webGpuVendorTest,
  chromeCapabilitiesTest,
  mediaCodecsDrmTest,
  webIdlSurfaceTest,
  eventSurfaceTest,
  eventTrustOverrideTest,
  rawCdpVisibilityTest,
  crossRealmTest,
  featureInventoryTest,
  canvasRenderingTest,
  webGlRenderingTest,
  webGpuRenderingTest,
  domSvgGeometryTest,
  cssSystemTest,
  audioTest,
  javascriptRuntimeTest,
  screenDprTest,
  viewportTest,
  storageCapabilitiesTest,
  mediaDevicesTest,
  proxyFunctionalityTest,
  http3SupportTest,
  quicConnectionTest,
  ja4FingerprintTest,
  stabilityTest,
];
